module.exports = __webpack_public_path__ + "img/fr_Ecran 4.9e477595.png";